import { BulkTrainerActionResultApi } from "api/trainers/trainerAccountApi";

export const getBulkTrainerActionSummaryLine = (
  result: BulkTrainerActionResultApi,
  successVerb: string,
  totalLabel: string,
): string => {
  const total = result.succeeded.length + result.skipped.length;
  return `${successVerb} dla ${result.succeeded.length}/${total} ${totalLabel}.`;
};

export type BulkTrainerActionLevel = "success" | "warning" | "error";

export const getBulkTrainerActionLevel = (result: BulkTrainerActionResultApi): BulkTrainerActionLevel => {
  if (result.skipped.length === 0) return "success";
  return result.succeeded.length === 0 ? "error" : "warning";
};
